module.exports = __webpack_public_path__ + "img/search-result.94483d7a.jpg";